import React, { Component, createRef } from "react";

import Slider from "react-slick";
import ReCAPTCHA from "react-google-recaptcha";
import EnquiryFormModal from "./EnquiryFormModal";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import ExploreRange from "./ExploreRange";
import { hasSubmittedToday, markSubmittedToday, DUPLICATE_LEAD_MESSAGE } from "../../../Common/leadDedupe";

const mgLogo =
    "/kial.png";


const banner1img =
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fbncap_d_2.avif?alt=media&token=1878cc8b-e64d-4285-85eb-1e45835f751b";

const banner2img =
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fseltos_d_1.avif?alt=media&token=9416699a-1899-41e1-a464-395d6fe94c73";

const banner3img =
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/Background%2Fclavis_d.avif?alt=media&token=7ea0de2d-6077-42ba-8d9d-b6bdd7ce61b9";
const inputStyle = {
    width: "100%",
    height: window.innerWidth <= 768 ? "56px" : "60px",
    padding: "0 18px",
    borderRadius: "16px",
    border: "1px solid #e3e3e3",
    background: "#fafafa",
    color: "#111",
    fontSize: window.innerWidth <= 768 ? "15px" : "16px",
    outline: "none",
    boxSizing: "border-box",
};
class Connect extends Component {
    constructor(props) {
        super(props);

        this.sliderRef = createRef();
        this.recaptchaRef = createRef();

        this.state = {
            mediaItems: [
                { type: "image", url: banner1img },
                { type: "image", url: banner2img },
                { type: "image", url: banner3img },
            ],
            enquiryOpen: false,
            name: "",
            email: "",
            mobile: "",
            location: "",
            model: "",
            loading: false,
            successMessage: "",
            errorMessage: "",
            otherLocation: "",
            captchaToken: null,
        };
    }


    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    handleCaptchaChange = (token) => {
        this.setState({ captchaToken: token });
    };

    handleSubmit = async (e) => {

        e.preventDefault();

        const {
            name,
            email,
            mobile,
            location,
            model,
        } = this.state;

        // VALIDATION
        if (
            !name ||
            !email ||
            !mobile ||
            !location ||
            !model ||
            (location === "Other" && !this.state.otherLocation)
        ) {
            this.setState({
                errorMessage: "Please fill all fields",
            });

            return;
        }

        const emailRegex =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {

            this.setState({
                errorMessage: "Invalid email address",
            });

            return;
        }

        const mobileRegex = /^[0-9]{10}$/;

        if (!mobileRegex.test(mobile)) {

            this.setState({
                errorMessage: "Invalid mobile number",
            });

            return;
        }

        if (hasSubmittedToday(mobile)) {

            this.setState({
                errorMessage: DUPLICATE_LEAD_MESSAGE,
            });

            return;
        }

        if (!this.state.captchaToken) {
            this.setState({
                errorMessage: "Please verify you're not a robot",
            });

            return;
        }

        try {

            this.setState({
                loading: true,
                errorMessage: "",
                successMessage: "",
            });

            const response = await fetch(
                "https://api.centralkia.co.in/api/enquiry/add-enquiry",
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json",
                    },

                    body: JSON.stringify({
                        name,
                        email,
                        mobile,
                        location:
                            location === "Other"
                                ? this.state.otherLocation
                                : location,
                        model,
                        captchaToken: this.state.captchaToken,
                    }),
                }
            );

            const data = await response.json();

            if (
                data.statusCode === 200 ||
                data.statusCode === 201
            ) {
                // Google Ads Conversion Tracking
                console.log("Google Ads Conversion Fired - Main Form");

                if (typeof window.gtag === "function") {
                    window.gtag("event", "conversion", {
                        send_to: "AW-705253839/dpJXCM6N-7kcEM-jpdAC",
                        value: 1.0,
                        currency: "INR",
                    });
                }
                markSubmittedToday(mobile);
                this.recaptchaRef.current?.reset();

                this.setState({
                    loading: false,

                    successMessage:
                        "Enquiry submitted successfully",

                    name: "",
                    email: "",
                    mobile: "",
                    location: "",
                    model: "",
                    otherLocation: "",
                    captchaToken: null,
                });

            } else {

                this.recaptchaRef.current?.reset();

                this.setState({
                    loading: false,
                    errorMessage: data.message,
                    captchaToken: null,
                });

            }

        } catch (error) {

            this.recaptchaRef.current?.reset();

            this.setState({
                captchaToken: null,
                loading: false,
                errorMessage: "Something went wrong",
            });

        }
    };
    // componentDidMount ADD KARO
    componentDidMount() {
        setTimeout(() => {
            this.setState({ enquiryOpen: true });
        }, 2500);
    }

    render() {
        const sliderSettings = {
            dots: true,
            infinite: true,
            speed: 800,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3500,
            arrows: false,
            pauseOnHover: false,
            swipeToSlide: true,
        };

        return (
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    fontFamily: "Arial, sans-serif",
                    backgroundColor: "#000",
                }}
            >

                {/* Header */}
                <header
                    style={{
                        backgroundColor: "#000",
                        color: "#fff",
                        padding: window.innerWidth <= 768 ? "10px 12px" : "10px 22px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        zIndex: 1000,
                        boxSizing: "border-box",
                    }}
                >
                    {/* Left Logos */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: window.innerWidth <= 768 ? "6px" : "10px",
                        }}
                    >
                        {/* MG Logo */}
                        <img
                            src={mgLogo}
                            alt="MG Logo"
                            style={{
                                height: window.innerWidth <= 768 ? "24px" : "40px",
                                width: "auto",
                                objectFit: "contain",
                            }}
                        />


                    </div>

                    {/* Button */}

                    <button
                        onClick={() => this.setState({ enquiryOpen: true })}
                        style={{
                            backgroundColor: "#d12230",
                            color: "#fff",
                            border: "none",
                            padding:
                                window.innerWidth <= 768 ? "7px 10px" : "9px 14px",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontWeight: "600",
                            fontSize:
                                window.innerWidth <= 768 ? "10px" : "12px",
                            whiteSpace: "nowrap",
                        }}
                    >
                        Book a Test Drive
                    </button>
                </header>

                {/* Main Content */}
                <main
                    style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        marginTop: window.innerWidth <= 768 ? "72px" : "85px",
                    }}
                >
                    {/* Hero Slider */}
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            backgroundColor: "#000",
                        }}
                    >
                        <Slider ref={this.sliderRef} {...sliderSettings}>
                            {this.state.mediaItems.map((item, index) => (
                                <div key={index}>
                                    <div
                                        style={{
                                            width: "100%",
                                            height:
                                                window.innerWidth <= 768
                                                    ? "auto"
                                                    : window.innerWidth <= 1024
                                                        ? "100vh"
                                                        : "70vh",
                                            overflow: "hidden",
                                            backgroundColor: "#000",
                                        }}
                                    >
                                        <img
                                            src={item.url}
                                            alt={`slide-${index}`}
                                            style={{
                                                width: "100%",
                                                height:
                                                    window.innerWidth <= 768
                                                        ? "auto"
                                                        : "100%",
                                                objectFit:
                                                    window.innerWidth <= 768
                                                        ? "contain"
                                                        : "cover",
                                                objectPosition: "center",
                                                display: "block",
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </Slider>

                        {/* Left Arrow */}
                        <button
                            onClick={() => this.sliderRef.current.slickPrev()}
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "15px",
                                transform: "translateY(-50%)",
                                background: "rgba(255,255,255,0.6)",
                                border: "none",
                                width: window.innerWidth <= 768 ? "35px" : "42px",
                                height: window.innerWidth <= 768 ? "35px" : "42px",
                                borderRadius: "50%",
                                cursor: "pointer",
                                fontSize: window.innerWidth <= 768 ? "16px" : "20px",
                                fontWeight: "bold",
                                zIndex: 10,
                            }}
                        >
                            &#10094;
                        </button>

                        {/* Right Arrow */}
                        <button
                            onClick={() => this.sliderRef.current.slickNext()}
                            style={{
                                position: "absolute",
                                top: "50%",
                                right: "15px",
                                transform: "translateY(-50%)",
                                background: "rgba(255,255,255,0.6)",
                                border: "none",
                                width: window.innerWidth <= 768 ? "35px" : "42px",
                                height: window.innerWidth <= 768 ? "35px" : "42px",
                                borderRadius: "50%",
                                cursor: "pointer",
                                fontSize: window.innerWidth <= 768 ? "16px" : "20px",
                                fontWeight: "bold",
                                zIndex: 10,
                            }}
                        >
                            &#10095;
                        </button>
                    </div>

                    {/* ENQUIRY FORM SECTION */}

                    <section
                        style={{
                            width: "100%",
                            background: "#fff",
                            padding:
                                window.innerWidth <= 768
                                    ? "35px 14px"
                                    : "70px 20px",

                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",

                            boxSizing: "border-box",
                        }}
                    >
                        <div
                            style={{
                                width:
                                    window.innerWidth <= 768
                                        ? "100%"
                                        : "80%",

                                maxWidth: "850px",

                                background: "#fff",

                                borderRadius:
                                    window.innerWidth <= 768
                                        ? "24px"
                                        : "20px",

                                padding:
                                    window.innerWidth <= 768
                                        ? "28px 18px"
                                        : "50px",

                                boxShadow:
                                    "0 10px 40px rgba(0,0,0,0.08)",

                                border: "1px solid #f1f1f1",

                                boxSizing: "border-box",
                            }}
                        >

                            {/* HEADING */}
                            <h1
                                style={{
                                    margin: 0,
                                    color: "#111",

                                    fontSize:
                                        window.innerWidth <= 768
                                            ? "34px"
                                            : "48px",

                                    fontWeight: "800",

                                    textAlign: "center",

                                    lineHeight: "1.1",
                                }}
                            >
                                ENQUIRE NOW
                            </h1>

                            <p
                                style={{
                                    marginTop: "14px",
                                    marginBottom: "35px",

                                    color: "#666",

                                    textAlign: "center",

                                    fontSize:
                                        window.innerWidth <= 768
                                            ? "13px"
                                            : "16px",

                                    lineHeight: "1.6",

                                    letterSpacing: "0.5px",
                                }}
                            >
                                OFFERS | TEST DRIVE | BOOK NOW
                            </p>

                            {/* SUCCESS */}
                            {/* SUCCESS POPUP */}
                            {this.state.successMessage && (
                                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        background: "rgba(0,0,0,0.7)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: 999999,
                                        padding: "20px",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <div
                                        style={{
                                            width:
                                                window.innerWidth <= 768
                                                    ? "92%"
                                                    : "420px",

                                            background: "#fff",

                                            borderRadius:
                                                window.innerWidth <= 768
                                                    ? "24px"
                                                    : "20px",

                                            padding:
                                                window.innerWidth <= 768
                                                    ? "35px 22px"
                                                    : "45px 35px",

                                            textAlign: "center",

                                            position: "relative",

                                            boxShadow:
                                                "0 15px 45px rgba(0,0,0,0.2)",

                                            animation: "popupShow 0.3s ease",
                                        }}
                                    >

                                        {/* ICON */}
                                        <div
                                            style={{
                                                width: "85px",
                                                height: "85px",
                                                borderRadius: "50%",
                                                background: "#eaf8ee",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                margin: "0 auto 22px auto",
                                                fontSize: "42px",
                                            }}
                                        >
                                            🙏
                                        </div>

                                        {/* TITLE */}
                                        <h2
                                            style={{
                                                margin: 0,
                                                color: "#111",

                                                fontSize:
                                                    window.innerWidth <= 768
                                                        ? "30px"
                                                        : "36px",

                                                fontWeight: "800",

                                                lineHeight: "1.2",
                                            }}
                                        >
                                            Thank You!
                                        </h2>

                                        {/* MESSAGE */}
                                        <p
                                            style={{
                                                marginTop: "14px",
                                                marginBottom: "30px",

                                                color: "#666",

                                                lineHeight: "1.7",

                                                fontSize:
                                                    window.innerWidth <= 768
                                                        ? "14px"
                                                        : "15px",
                                            }}
                                        >
                                            Your enquiry has been submitted
                                            successfully. Our team will
                                            contact you shortly.
                                        </p>

                                        {/* BUTTON */}
                                        <button
                                            onClick={() =>
                                                this.setState({
                                                    successMessage: "",
                                                })
                                            }
                                            style={{
                                                width: "100%",
                                                height:
                                                    window.innerWidth <= 768
                                                        ? "54px"
                                                        : "58px",

                                                border: "none",

                                                borderRadius: "16px",

                                                background: "#d91c2b",

                                                color: "#fff",

                                                fontSize:
                                                    window.innerWidth <= 768
                                                        ? "15px"
                                                        : "16px",

                                                fontWeight: "700",

                                                cursor: "pointer",

                                                transition: "0.3s",
                                            }}
                                        >
                                            OKAY
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* ERROR */}
                            {this.state.errorMessage && (
                                <div
                                    style={{
                                        background: "#f8d7da",
                                        color: "#721c24",
                                        padding: "14px",
                                        borderRadius: "12px",
                                        marginBottom: "18px",
                                        textAlign: "center",
                                        fontWeight: "600",
                                    }}
                                >
                                    {this.state.errorMessage}
                                </div>
                            )}

                            <form onSubmit={this.handleSubmit}>

                                {/* NAME + EMAIL */}
                                <div
                                    style={{
                                        display: "grid",

                                        gridTemplateColumns:
                                            window.innerWidth <= 768
                                                ? "1fr"
                                                : "1fr 1fr",

                                        gap: "18px",

                                        marginBottom: "18px",
                                    }}
                                >

                                    {/* NAME */}
                                    <input
                                        type="text"
                                        required
                                        name="name"
                                        placeholder="First Name *"
                                        value={this.state.name}
                                        onChange={this.handleChange}
                                        style={inputStyle}
                                    />

                                    {/* EMAIL */}
                                    <input
                                        type="email"
                                        required
                                        name="email"
                                        placeholder="Email"
                                        value={this.state.email}
                                        onChange={this.handleChange}
                                        style={inputStyle}
                                    />
                                </div>

                                {/* PHONE */}
                                <div style={{ marginBottom: "18px" }}>
                                    <input
                                        type="tel"
                                        required
                                        name="mobile"
                                        maxLength="10"
                                        placeholder="Phone *"
                                        value={this.state.mobile}
                                        onChange={this.handleChange}
                                        style={inputStyle}
                                    />
                                </div>


                                {/* LOCATION */}
                                <div style={{ marginBottom: "18px" }}>
                                    <select
                                        required
                                        name="location"
                                        value={this.state.location}
                                        onChange={this.handleChange}
                                        style={inputStyle}
                                    >
                                        <option value="">
                                            Select Location
                                        </option>

                                        <option value="Bhubaneswar">
                                            Bhubaneswar
                                        </option>

                                        <option value="Angul">
                                            Angul
                                        </option>

                                        <option value="Raghunathpur">
                                            Raghunathpur
                                        </option>

                                        <option value="Berhampur">
                                            Berhampur
                                        </option>

                                        <option value="Sambalpur">
                                            Sambalpur
                                        </option>

                                        <option value="Cuttack">
                                            Cuttack
                                        </option>

                                        <option value="Other">
                                            Other
                                        </option>
                                    </select>
                                </div>

                                {/* OTHER LOCATION INPUT */}
                                {this.state.location === "Other" && (
                                    <div style={{ marginBottom: "18px" }}>
                                        <input
                                            type="text"
                                            required
                                            name="otherLocation"
                                            placeholder="Enter Your Location"
                                            value={this.state.otherLocation}
                                            onChange={this.handleChange}
                                            style={inputStyle}
                                        />
                                    </div>
                                )}

                                {/* MODEL */}
                                <div style={{ marginBottom: "26px" }}>
                                    <select
                                        required
                                        name="model"
                                        value={this.state.model}
                                        onChange={this.handleChange}
                                        style={inputStyle}
                                    >
                                        <option value="">
                                            Select Model
                                        </option>

                                        <option value="seltos">
                                            Seltos
                                        </option>

                                        <option value="sonet">
                                            Sonet
                                        </option>

                                        <option value="carens">
                                            Carens
                                        </option>


                                        <option value="carnival">
                                            Carnival
                                        </option>



                                        <option value="syros">
                                            Syros
                                        </option>

                                        <option value="syros ev">
                                            Syros EV
                                        </option>


                                        <option value="sorento">
                                            Sorento

                                        </option>
                                    </select>
                                </div>

                                {/* CAPTCHA */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        margin: "12px 0",
                                    }}
                                >
                                    {process.env.REACT_APP_RECAPTCHA_SITE_KEY ? (
                                        <ReCAPTCHA
                                            ref={this.recaptchaRef}
                                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                            onChange={this.handleCaptchaChange}
                                            onExpired={() =>
                                                this.setState({ captchaToken: null })
                                            }
                                        />
                                    ) : (
                                        <p style={{ color: "#d91c2b", fontSize: "13px" }}>
                                            Captcha not configured (missing REACT_APP_RECAPTCHA_SITE_KEY)
                                        </p>
                                    )}
                                </div>

                                {/* BUTTON */}
                                <button
                                    type="submit"
                                    disabled={this.state.loading}
                                    style={{
                                        width: "100%",

                                        height:
                                            window.innerWidth <= 768
                                                ? "56px"
                                                : "62px",

                                        borderRadius: "16px",

                                        border: "none",

                                        background: "#d91c2b",

                                        color: "#fff",

                                        fontSize:
                                            window.innerWidth <= 768
                                                ? "15px"
                                                : "16px",

                                        fontWeight: "700",

                                        cursor: "pointer",

                                        transition: "0.3s",

                                        opacity:
                                            this.state.loading
                                                ? 0.7
                                                : 1,
                                    }}
                                >
                                    {this.state.loading
                                        ? "Submitting..."
                                        : "SUBMIT ENQUIRY"}
                                </button>

                            </form>
                        </div>
                    </section>
                    <ExploreRange />
                    <EnquiryFormModal
                        open={this.state.enquiryOpen}
                        onClose={() => this.setState({ enquiryOpen: false })}
                    />

                </main>

                {/* Footer */}
                <footer
                    style={{
                        backgroundColor: "#000",
                        color: "#fff",
                        textAlign: "center",
                        padding: "15px",
                        lineHeight: "20px",
                        fontSize: "11px",
                    }}
                >
                    <div>
                        © 2026 Central Kia | Developed and Managed by KLI Advertising
                    </div>


                    <div style={{ marginTop: "5px" }}>
                        <Link
                            to="/terms-and-conditions"
                            style={{
                                color: "#fff",
                                textDecoration: "none",
                            }}
                        >
                            Terms and Conditions
                        </Link>

                        {" / "}

                        <Link
                            to="/privacy-policy"
                            style={{
                                color: "#fff",
                                textDecoration: "none",
                            }}
                        >
                            Privacy Policy
                        </Link>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Connect;